/**
 * Dropdown Styles
 */
export const dropdownStyles = {
  trigger: 'outline-none',
  content: 'translate-y-[1rem] !rounded-lg shadow-xl !px-0 min-w-[10rem]',
  item: '!cursor-pointer px-3 min-h-12 mb-2 hover:!bg-primary-50 hover:!text-gray-900 hover:[&>span]:!text-gray-900 !text-base !leading-[1.5rem]',
};

export const sidebarStyles = {
  base: 'h-screen w-full sm:w-[18rem] bg-white border-r border-gray-100 fixed left-0 top-0 shadow-md flex flex-col py-8 z-100 transition-all duration-300',
  mobile: {
    closed: '!left-[-100%] sm:!left-[-18rem]',
    open: '!left-0',
  },
};

/**
 * Textarea Color Styles
 */
export const textareaColorStyles = {
  default: {
    default:
      'bg-gray-50 border-2 border-gray-200 hover:bg-gray-100 hover:border-gray-400 focus-within:!border-purple-400 focus-within:[&+p]:!text-primary-500 focus-within:[&>span]:!text-primary-500',
    success:
      'bg-green-50 border-2 border-green-200 hover:bg-green-100 hover:border-green-400 [&+p]:!text-green-500 [&>span]:!text-green-500 focus-within:!border-purple-400 focus-within:[&+p]:!text-primary-500 focus-within:[&>span]:!text-primary-500',
    warning:
      'bg-yellow-50 border-2 border-yellow-200 hover:bg-yellow-100 hover:border-yellow-400 [&+p]:!text-yellow-500 [&>span]:!text-yellow-500 focus-within:!border-purple-400 focus-within:[&+p]:!text-primary-500 focus-within:[&>span]:!text-primary-500',
    error:
      'bg-red-50 border-2 border-red-200 hover:bg-red-100 hover:border-red-400 [&+p]:!text-red-500 [&>span]:!text-red-500 focus-within:!border-red-500 focus-within:[&+p]:!text-red-500 focus-within:[&>span]:!text-red-500',
    info: 'bg-blue-50 border-2 border-blue-200 hover:bg-blue-100 hover:border-blue-400 [&+p]:!text-blue-500 [&>span]:!text-blue-500 focus-within:!border-purple-400 focus-within:[&+p]:!text-primary-500 focus-within:[&>span]:!text-primary-500',
  },
  outline: {
    default:
      'bg-transparent autofill:bg-transparent border-2 border-gray-200 hover:border-primary-200 focus-within:!border-purple-400 focus-within:[&+p]:!text-primary-500',
    success:
      'bg-transparent autofill:bg-transparent border-2 border-green-200 hover:border-green-400 [&+p]:!text-green-500 [&>span]:!text-green-500 focus-within:!border-purple-400 focus-within:[&+p]:!text-primary-500 focus-within:[&>span]:!text-primary-500',
    warning:
      'bg-transparent autofill:bg-transparent border-2 border-yellow-200 hover:border-yellow-400 [&+p]:!text-yellow-500 [&>span]:!text-yellow-500 focus-within:!border-purple-400 focus-within:[&+p]:!text-primary-500 focus-within:[&>span]:!text-primary-500',
    error:
      'bg-transparent border-2 border-red-200 hover:border-red-400 [&+p]:!text-red-500 [&>span]:!text-red-500 focus-within:!border-red-500 focus-within:[&+p]:!text-red-500 focus-within:[&>span]:!text-red-500',
    info: 'bg-transparent border-2 border-blue-200 hover:border-blue-400 [&+p]:!text-blue-500 [&>span]:!text-blue-500 focus-within:!border-purple-400 focus-within:[&+p]:!text-primary-500 focus-within:[&>span]:!text-primary-500',
  },
};

export const textareaSizeClasses = ({ autogrow }: { autogrow: boolean }) => ({
  md: autogrow
    ? 'p-3 min-h-10 text-[0.875rem] leading-[1.25rem] rounded-xl'
    : 'p-3 h-10 text-[0.875rem] leading-[1.25rem] rounded-xl',
  lg: autogrow
    ? 'p-3 min-h-12 text-[1rem] leading-[1.25rem] rounded-xl'
    : 'p-3 h-12 text-[1rem] leading-[1.25rem] rounded-xl',
  xl: autogrow
    ? 'p-3 min-h-15 text-[1rem] leading-[1.5rem] rounded-xl'
    : 'p-3 h-15 text-[1rem] leading-[1.5rem] rounded-xl',
});

export const messageStyles = {
  messageLeftClassName:
    'bg-gray-100 p-6 w-fit max-w-[100%] rounded-xl rounded-tl-none font-medium',
  subMessageLeftClassName:
    'bg-gray-100 p-6 w-fit max-w-[100%] md:max-w-[60%] mb-12 rounded-xl rounded-tl-none font-semibold text-sm',
  messageRightClassName:
    'bg-primary-400 text-white py-3 px-5 rounded-xl rounded-br-none font-medium',
  messageRightClassNameMultiSelect:
    'flex flex-wrap justify-end gap-3 [&>*]:ml-0 w-fit mr-0',
  answerItemClassName: 'w-fit max-w-[100%] md:max-w-[60%] ml-auto mb-12',
  answerItemClassNameMultiSelect: 'md:max-w-[75%] max-w-[100%] ml-auto mb-12',
};

export const aiChatMessagesStyles = {
  baseClassName:
    'px-4 py-2 w-fit max-w-[90%] md:max-w-[60%] rounded-xl text-sm font-medium mb-6',
  messageLeftClassName: 'bg-theme-blue-25 ml-0 mr-auto rounded-bl-none',
  messageRightClassName: 'bg-purple-25 mr-0 ml-auto rounded-br-none',
  baseTimeStyles: 'text-xs text-body-300 font-semibold',
  timeLeftClassName: 'text-left',
  timeRightClassName: 'text-right',
};
